import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { ProjectRow, EmptyState } from "./components";

const TABS = ["All", "In Production", "Quality Check", "Ready", "Delivered"];
// Tab → backend status mapping (the studio's 4-stage production flow).
function matchesTab(brief, tab) {
  if (tab === "All") return true;
  if (tab === "In Production") return brief.status === "In Production";
  if (tab === "Quality Check") return brief.status === "QC Check";
  // Ready and Delivered both cover the final stage — files ready for download.
  if (tab === "Ready" || tab === "Delivered") return brief.status === "Delivered";
  return false;
}

export default function ProjectsPage() {
  const { briefs } = useOutletContext();
  const [tab, setTab] = useState("All");
  const filtered = [...briefs].filter((b) => matchesTab(b, tab)).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  return (
    <div data-testid="projects-page">
      <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-sky-400">Grapho Studio</p>
      <h1 className="mt-2 text-2xl font-extrabold tracking-tight text-white sm:text-3xl">My Projects</h1>
      <p className="mt-1 text-sm text-slate-400">Your full project library.</p>

      <div className="mt-6 flex flex-wrap gap-2">
        {TABS.map((t) => (
          <button
            key={t}
            data-testid={`projects-filter-${t.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            onClick={() => setTab(t)}
            className={`rounded-full border px-3.5 py-1.5 text-xs font-semibold transition-colors ${
              tab === t
                ? "border-amber-400/50 bg-amber-400/10 text-amber-300"
                : "border-white/10 bg-white/5 text-slate-400 hover:text-slate-200"
            }`}
          >
            {t}
          </button>
        ))}
      </div>

      {filtered.length === 0 ? (
        <div className="mt-6">
          <EmptyState
            testId="projects-empty"
            eyebrow="No projects here yet."
            text="Your next design starts here. Submit a brief and our creative team will take it from there."
          />
        </div>
      ) : (
        <div data-testid="projects-list" className="mt-6 space-y-3">
          {filtered.map((b) => (
            <ProjectRow key={b.brief_id} brief={b} download />
          ))}
        </div>
      )}
    </div>
  );
}
